<div class="language-switcher" ngbDropdown>
  <button 
    class="btn btn-outline-secondary dropdown-toggle d-flex align-items-center" 
    type="button" 
    id="languageDropdown" 
    ngbDropdownToggle
    [title]="'SETTINGS.LANGUAGE' | translate">
    <span class="me-2">{{ getCurrentLanguageFlag() }}</span>
    <span class="d-none d-md-inline">{{ getCurrentLanguageName() }}</span>
  </button>
  
  <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu aria-labelledby="languageDropdown">
    <button 
      *ngFor="let language of languages"
      class="dropdown-item d-flex align-items-center" 
      type="button"
      [class.active]="currentLanguage === language.code"
      (click)="changeLanguage(language.code)">
      <span class="me-2">{{ language.flag }}</span>
      <span>{{ language.name }}</span>
      <i *ngIf="currentLanguage === language.code" class="fas fa-check ms-auto text-primary"></i>
    </button>
  </div>
</div>
